<template>
  <base-section
  id="visionary"
  >
    <v-container>
    <base-section-heading
    title="Visionary Talks"
    color="secondary"
    align="left"
    :toColor="true"
    >
<strong>
You can find below the information about the Visionary talks of LATS2025.
<br>
</strong>
</base-section-heading>
<div
  v-for="talk in talks"
  :key="talk.typeTalk"
>
<base-section-heading
:title="talk.typeTalk"
color="secondary"
align="left"
:toColor="true"
>
<div
v-for="subtalk in talk.subTalks"
:key="subtalk.talkTitle"
>
<enhanced-profile-card
  v-bind="subtalk"
  />
</div>
</base-section-heading>
</div>
    </v-container>
  </base-section>
</template>

<script>
import EnhancedProfileCard from "@/components/base/EnhancedProfileCard.vue"

export default {
    name: 'visionary',
    components: {
      EnhancedProfileCard,
    },
    data: () => ({
      talks: [
        {
            typeTalk: "Visionary Talk 1",
            subTalks: [
              {
                profileImage: require('@/images/talks/blanton.png'),
                profileName: "Shawn Blanton",
                profileSubtitle: "Carnegie Mellon University, USA",
                talkTitle: "CHEF: CHaracterizing Elusive Failures",
                abstract: "Backside power delivery used within modern ICs complicates failure analysis by obstructing access to transistors with dense metal layers, interfering with optical techniques, and increasing sample preparation complexity. As a result, there will be an increased emphasis on failure characterization that does not require physical access but instead more heavily relies on simulation and modeling. CHEF (Characterizing Elusive Failures) is a new approach that does not score a finite a set of fault models (e.g., opens, bridges, cell, etc.) but instead (i) identifies a parameterizable three-dimensional region that bounds the failure, and then (ii) precisely characterizes the changes in the circuit functionality due to the failure. In other words, CHEF derives a custom fault model for a given IC failure. In this talk, the various aspects of CHEF will be described and its application demonstrated on actual failures fabricated in the latest technologies.",
                bio: "Shawn Blanton is the Joseph F. and Nancy Keithley Professor of Electrical and Computer Engineering (ECE) Department at Carnegie Mellon University, where he also serves as the department’s Associate Head of Research. His research interests are housed in the Advanced Chip Testing Laboratory (www.ece.cmu.edu/~actl) and include the design, test, diagnosis and security of integrated systems. He has published over 200 papers in these areas and has several issued and pending patents. Prof. Blanton has received the National Science Foundation Career Award for the development of a microelectromechanical systems (MEMS) testing methodology, and several industrial faculty awards from companies such as IBM, Qualcomm, Google, Teradyne and CISCO. He is a Fellow of the IEEE, and senior member of the ACM.",
              },
            ],
        },
      ],
    }),
};
</script>

<style>
.v-application .grey--text.text--darken-1 {
  color: black !important;
}
.v-application .grey--text.text--lighten-1 {
  color: white !important;
}
.v-card, .v-card__title {
  word-break: unset !important;
  letter-spacing: unset !important;
  text-align: justify !important;
}
</style>
